import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { getDomainValueForCode } from '../../../library/Core/SmartFunctions';
import moment from 'moment';
const ViewDescriptionModal = () => {
    const { state, dispatch } = useContext(SmartContext);
    const showFlag = state?.modalFlags?.showJobPostingViewDescription;
    const jobData = state?.modalData?.data;
    console.log('jobData', jobData);

    useEffect(() => {
        const handleEsc = (event: KeyboardEvent) => {
            if (event.key === 'Escape' && showFlag) {
                dispatch({
                    type: 'TOGGLE_MODAL_VISIBILITY',
                    payload: { modalName: 'showJobPostingViewDescription' },
                });
            }
        };

        document.addEventListener('keydown', handleEsc);

        return () => {
            document.removeEventListener('keydown', handleEsc);
        };
    }, [showFlag, dispatch]);

    const htmlToListItems = (html?: string) => {
        if (!html) return [];

        // Replace paragraph and break tags with newline
        const text = html
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/<\/p>/gi, '\n')
            .replace(/<[^>]+>/g, '') // remove all HTML tags
            .trim();

        return text
            .split('\n')
            .map((line) => line.trim())
            .filter((line) => line.length > 0);
    };

    return (
        <div
            className={`modal fade px-3 ${showFlag ? 'show' : ''}`}
            id="jobDescriptionModal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex={-1}
            style={{ display: showFlag ? 'block' : 'none' }}>
            <div className="modal-dialog modal-dialog-centered max-850 mx-auto">
                <div className="modal-content radius-15">
                    <div className="modal-body p-4 p-md-5">
                        <h5 className="font-30 font-600 mb-2" id="staticBackdropLabel">
                            {jobData?.title} @{' '}
                            {jobData?.companyId ? getDomainValueForCode(jobData?.companyId, 'COMPANY_CODE', state) : jobData?.otherCompany}
                        </h5>
                        <hr className="m-0 opacity-10 mb-4" />
                        <button
                            type="button"
                            className="btn-close btn-close-small text-secondary font-30"
                            onClick={() => {
                                dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'showJobPostingViewDescription' } });
                            }}
                            aria-label="Close"></button>

                        <div className="row g-3">
                            <div className="col-md-12">
                                <h2 className="font-35 font-600 d-flex align-items-center">
                                    {jobData?.jobTypeCode}
                                    <span className="badge text-bg-secondary bg-opacity-25 rounded-pill font-14 font-400 align-top ms-3 text-black px-3">
                                        {moment().diff(jobData?.createdAt, 'days') > 0
                                            ? moment().diff(jobData?.createdAt, 'days') + 'days ago'
                                            : 'today'}
                                    </span>
                                </h2>
                                <h3 className="font-30 font-600">
                                    {jobData?.title} @{' '}
                                    {jobData?.companyId
                                        ? getDomainValueForCode(jobData?.companyId, 'COMPANY_CODE', state)
                                        : jobData?.otherCompany}
                                </h3>
                                <div className="row g-3 align-items-center">
                                    <div className="col-auto">
                                        <i className="bi bi-geo-alt-fill me-2 text-dark-blue"></i>
                                        {jobData?.cityCode ? getDomainValueForCode(jobData?.cityCode, 'CITY_CODE', state) : ''}
                                        {','}
                                        {jobData?.countryId ? getDomainValueForCode(jobData?.countryId, 'COUNTRY_CODE', state) : ''}
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-briefcase-fill me-2 text-dark-blue"></i>{' '}
                                        {jobData?.experienceLevelCode ? getDomainValueForCode(jobData?.experienceLevelCode, 'WORK_EX_PREFERENCE', state) : ''} Experience                                        
                                    </div>
                                    <div className="col-auto">
                                        <i className="icon-hand-rupee me-2 text-dark-blue"></i>₹
                                        {jobData?.salaryCode?.replaceAll('_', ' to ')} LPA
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <hr className="m-0 opacity-10" />
                            </div>
                            <div className="col-md-12">
                                <h4 className="font-20 font-600">About The Role</h4>
                                <p className="mb-0">
                                    <div dangerouslySetInnerHTML={{ __html: jobData?.description || 'NA' }}></div>
                                </p>
                            </div>
                            <div className="col-md-12">
                                <hr className="m-0 opacity-10" />
                            </div>
                            <div className="col-md-12">
                                <h4 className="font-20 font-600">Key Responsibilities</h4>

                                <div dangerouslySetInnerHTML={{ __html: jobData?.keyResponsibility || 'NA' }}></div>
                            </div>
                            <div className="col-md-12">
                                <hr className="m-0 opacity-10" />
                            </div>
                            <div className="col-md-12">
                                <h4 className="font-20 font-600">Requirements</h4>

                                <div dangerouslySetInnerHTML={{ __html: jobData?.jobRequirement || 'NA' }}></div>
                            </div>
                            <div className="col-md-12">
                                <hr className="m-0 opacity-10" />
                            </div>
                            <div className="col-md-12">
                                <h4 className="font-20 font-600">Benefits</h4>
                                <div dangerouslySetInnerHTML={{ __html: jobData?.benefits || 'NA' }}></div>
                                <div className="bg-gray-f5 rounded p-3">
                                    <h4 className="font-20 font-600">About the Company</h4>
                                    <div className="row g-0">
                                        <div className="col-12">
                                            <span className="font-500">Posted by:</span> {jobData?.firstName + ' ' + jobData?.lastName},
                                            {jobData?.programName}{' '}
                                        </div>
                                        <div className="col-12">
                                            <span className="font-500">Contact:</span>{' '}
                                            {jobData?.contactEmail ? jobData?.contactEmail : 'NA'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewDescriptionModal;
